import type { RouteRecordRaw } from 'vue-router';

export const cardsRoutes = [
  {
    path: 'cards',
    name: 'cards',
    component: () => import('./CardsPage.vue'),
    meta: { title: 'Cards' },
  },
] as const satisfies readonly RouteRecordRaw[];
